class ListingResponse {
  constructor(listingData) {
    this.resources = listingData?.data || [];
    this.total = +listingData?.total || 0;
    this.meta = listingData || {};
  }
}

export default ListingResponse;
